export default __webpack_public_path__ + "static/media/Head_6_Ear_2_C5.0ebf85f2.svg";